export const USER_PUSH_TOKEN = '/api/v1/user/notifications/token-add';
export const REMOVE_PUSH_TOKEN = '/api/v1/user/notifications/token-remove';
export const LAST_PUSH_TOKEN_KEY = 'lastPushToken';
